// Some embedding shells (an Electron wrapper, reported in Sentry) hand `window.open` back as an object
// with no callable `close`, so calling it threw out of a connect flow's `finally` — reporting a
// connection that succeeded as a failure. Every OAuth popup close goes through here.
export function closePopup(popup: Window | null | undefined): void {
  if (typeof popup?.close === 'function') popup.close();
}
